import React from 'react';
import Layout from '../components/Layout';

export default function ContactUs() {
  return (
    <Layout>
      <div className="page-banner">
        <h1>Contact Us</h1>
      </div>
      <div className="main-content">

        {/* Intro */}
        <div className="about-mission" style={{ marginBottom: '2rem' }}>
          <p style={{ fontSize: '1.05rem' }}>
            We're here to help with your questions, feedback, and support requests.
            Whether you need help finding the right guide, want to report an issue, or are interested
            in our business support services, our team is happy to assist.
          </p>
        </div>

        <div className="contact-grid">

          {/* Left column — info boxes */}
          <div>

            {/* How to Reach Us */}
            <div className="contact-info-box" style={{ marginBottom: '1.5rem' }}>
              <h3>How to Reach Us</h3>

              <p style={{ marginTop: '0.75rem' }}>
                <strong>📧 Email Support</strong><br />
                For general questions, technical concerns, content corrections, or business inquiries:
              </p>
              <p style={{ marginTop: '0.4rem' }}>
                <a href="mailto:contact@smartdeviceassistant.com">contact@smartdeviceassistant.com</a>
              </p>

              <p style={{ marginTop: '1rem' }}>
                <strong>💼 Business &amp; Partnership Inquiries</strong><br />
                Organizations interested in our B2B support services can also reach our team at:
              </p>
              <p style={{ marginTop: '0.4rem' }}>
                <a href="mailto:contact@smartdeviceassistant.com">contact@smartdeviceassistant.com</a>
              </p>

              <p style={{ marginTop: '1rem' }}>
                <strong>📝 Feedback &amp; Corrections</strong><br />
                Found outdated information or a guide that needs improvement? Let us know — we
                actively review reader feedback to keep our content accurate and useful.
              </p>
            </div>

            {/* Response Time */}
            <div className="contact-info-box" style={{ marginBottom: '1.5rem' }}>
              <h3>Response Time</h3>
              <p>
                We aim to respond to most inquiries within <strong>1–2 business days</strong>.
                Response times may vary depending on inquiry volume and the complexity of the request.
              </p>
            </div>

            {/* Important Notice */}
            <div className="disclaimer-box">
              <h3>Important Notice</h3>
              <p>
                Smart Device Assistant is an independent informational platform and is not affiliated
                with HP, Canon, Epson, Brother, Amazon, Arlo, or any other hardware manufacturer or
                software provider mentioned on this website.
              </p>
              <p style={{ marginTop: '0.6rem' }}>
                We provide free educational content for consumers and paid support services for
                businesses, but we do not represent official manufacturer support unless explicitly stated.
              </p>
            </div>

          </div>

          {/* Right column — map */}
          <div>
            <div className="map-container">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d26372940.769881584!2d-113.74801011485563!3d36.20661107685515!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x54eab584e432360b%3A0x1c3bb99243deb742!2sUnited%20States!5e0!3m2!1sen!2sin!4v1646830811822!5m2!1sen!2sin"
                title="Office Location"
                allowFullScreen=""
                loading="lazy"
              />
            </div>
          </div>

        </div>

      </div>
    </Layout>
  );
}
